import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { LaravelJWTScheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": false,
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "laravelJWT"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // laravelJWT
  $auth.registerStrategy('laravelJWT', new LaravelJWTScheme($auth, {
  "_scheme": "refresh",
  "url": "https://apiv2.sysero.nl",
  "autoRefresh": true,
  "token": {
    "property": "authorisation.token",
    "maxAge": 3600,
    "required": true,
    "type": "Bearer"
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": false,
    "maxAge": 2592000,
    "required": false,
    "tokenRequired": true
  },
  "user": {
    "property": false,
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "https://apiv2.sysero.nl/api/mvh/login",
      "method": "post",
      "propertyName": "token"
    },
    "refresh": {
      "url": "https://apiv2.sysero.nl/api/mvh/refresh",
      "method": "post"
    },
    "logout": {
      "url": "https://apiv2.sysero.nl/api/mvh/logout",
      "method": "post"
    },
    "user": {
      "url": "https://apiv2.sysero.nl/api/mvh/user?query=(include:((subscriptions:include:((resource:(include:((resources:(filters:(types:(0:show)))))),detail:(),recurring:(),period:(),transaction:())),favorites:())))",
      "method": "get"
    }
  },
  "name": "laravelJWT",
  "clientId": false,
  "grantType": false
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
